import React from "react";
import { FaSchool } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import ParentPortalMobileNav from "./ParentPortalMobileNav";
import type { ParentActionsView } from "./ParentActionsSubnav";

type TabItem = { key: string; label: string };

interface ParentPortalMobileShellProps {
  tabItems: TabItem[];
  activeTab: string;
  setActiveTab: (key: any) => void;
  familyName?: string;
  schoolName?: string;
  children: React.ReactNode;
  onOpenProfile?: () => void;
  onOpenSettings?: () => void;
  onOpenCalendarLink?: () => void;
  showTeacherPortal?: boolean;
  onOpenTeacherPortal?: () => void;
  directorySearch?: {
    value: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
    loading?: boolean;
    placeholder?: string;
  };
  actionsView: ParentActionsView;
  setActionsView: (view: ParentActionsView) => void;
  openActionsCount: number;
  schoolTasksCount: number | null;
  showSchoolTasks: boolean;
  openActionsLabel: string;
  schoolTasksLabel: string;
}

const SchoolIcon = FaSchool as any;

export default function ParentPortalMobileShell({
  tabItems,
  activeTab,
  setActiveTab,
  familyName,
  schoolName,
  children,
  onOpenProfile,
  onOpenSettings,
  onOpenCalendarLink,
  showTeacherPortal = false,
  onOpenTeacherPortal,
  directorySearch,
  actionsView,
  setActionsView,
  openActionsCount,
  schoolTasksCount,
  showSchoolTasks,
  openActionsLabel,
  schoolTasksLabel,
}: ParentPortalMobileShellProps) {
  const { t } = useTranslation();
  const displayFamilyName = familyName || "";
  const displaySchoolName = schoolName || "";

  return (
    <div className="pp-mobile-shell lg:hidden">
      <main className="pp-mobile-main" aria-label={t("parentPortal.title", { defaultValue: "Parent portal" })}>
        <header className="pp-mobile-header">
          <div className="pp-mobile-header-copy">
            {displaySchoolName && (
              <div className="pp-mobile-school-line">
                <SchoolIcon aria-hidden="true" />
                <span>{displaySchoolName}</span>
              </div>
            )}

            {displayFamilyName && <h1>{displayFamilyName}</h1>}
          </div>
        </header>

        <div className="pp-mobile-content">{children}</div>
      </main>

      <ParentPortalMobileNav
        tabItems={tabItems}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onOpenProfile={onOpenProfile}
        onOpenSettings={onOpenSettings}
        onOpenCalendarLink={onOpenCalendarLink}
        showAdminPortal={showTeacherPortal}
        onOpenAdminPortal={onOpenTeacherPortal}
        directorySearch={directorySearch}
        actionsView={actionsView}
        setActionsView={setActionsView}
        openActionsCount={openActionsCount}
        schoolTasksCount={schoolTasksCount}
        showSchoolTasks={showSchoolTasks}
        openActionsLabel={openActionsLabel}
        schoolTasksLabel={schoolTasksLabel}
      />
    </div>
  );
}
